//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    feedIds: {
      type: Array,
      required: true
    },
    levelIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      feedsIsSubscribed: [],
      feedsIsSubscribedStartState: []
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    }
  },
  async mounted() {
    if (this.account) {
      const { data } = await this.$axios.get(`${this.$config.apiRestUrl}/feed/GetUserFeeds?subscribed=true`)
      this.feedsIsSubscribed = this.feedIds.map((x) => data.includes(x.feedId))
      this.feedsIsSubscribedStartState = this.feedIds.map((x) => data.includes(x.feedId))
    }
  },
  methods: {
    async onUpdate() {
      this.loading = true
      await this.$axios.$post(`${this.$config.apiRestUrl}/feed/UpdateUserFeeds`, {
        feeds: this.feedsIsSubscribed
          .map((x, index) => {
            return {
              idFeed: this.feedIds[index].feedId,
              subscribed: x
            }
          })
          .filter((x, index) => this.feedsIsSubscribedStartState[index] !== x.subscribed),
        levelIds: this.levelIds,
        isSubscribedToAny: this.feedsIsSubscribed.includes(true)
      })

      this.feedsIsSubscribedStartState = [...this.feedsIsSubscribed]

      this.$buefy.notification.open({
        duration: 5000,
        message: this.$t('newsletter.success'),
        type: 'is-success'
      })

      this.loading = false
    }
  }
}
